import Upload from '@common/Upload'
import VerticalImgUploader from '@common/VerticalImgUploader'
import { getImageAutoOrientLink, getImageSizeByFile } from '@util'
import { message } from 'hljd'
import React, { Component, Fragment } from 'react'
import Style from './style.module.less'
import { isWeddingDressProperty } from '@merchant-backend/util'

export default class extends Component {
  onCliped = type => (e, info) => {
    if (type == 'cover_img') {
      if (e.pixel.height < 675 || e.pixel.width < 1080) {
        return message.error('图片宽度需大于1080，高度需大于675')
      }
    } else {
      // 婚纱礼服商家
      if (isWeddingDressProperty()) {
        if (e.pixel.height < 702 || e.pixel.width < 526) {
          return message.error('图片宽度需大于526，高度需大于702')
        }
      } else {
        if (e.pixel.height < 540 || e.pixel.width < 540) {
          return message.error('图片宽度需大于540，高度需大于540')
        }
      }
    }

    const href = getImageAutoOrientLink(e.clipUrl, info)

    const image = {
      // href: e.clipUrl,
      href,
      pixel: {
        x: e.pixel.x,
        y: e.pixel.y,
        h: e.pixel.height,
        w: e.pixel.width
      }
    }

    const { value, onChange, checkCMYK } = this.props
    const result = Object.assign({}, value, {
      [type]: image
    })

    onChange(result)
    checkCMYK && checkCMYK(2, e.data)
  }

  onBeforeUp = async file => {
    const { width, height } = await getImageSizeByFile(file.getNative())
    if (width < 1080 || height < 675) {
      message.error(`图片尺寸太小，请重新上传`)
      return Promise.reject()
    }
    return Promise.resolve()
  }

  onDelete = type => () => {
    const { value, onChange } = this.props
    const result = Object.assign({}, value, {
      [type]: null
    })
    onChange(result)
  }

  render() {
    const style = {
      display: 'inline-block',
      marginRight: '20px',
      lineHeight: 0
    }
    const { value, isMutile } = this.props
    const coverImg =
      value && value.cover_img && value.cover_img.href
        ? value.cover_img.href
        : ''
    const upCoverImg =
      value && value.up_cover_img && value.up_cover_img.href
        ? value.up_cover_img.href
        : ''

    const _isWeddingDressProperty = isWeddingDressProperty()
    const verticalImgText = _isWeddingDressProperty ? '竖图' : '方图'
    return (
      <Fragment>
        <div style={{ margin: '9px 0 8px 0' }}>
          <p className={Style.text_desc}>
            1.横图在案例列表展示，{verticalImgText}在首页推荐展示，更真实、直观地表达案例特色，可快速提升成交转化；
          </p>
          <p className={Style.text_desc}>
            2.尺寸格式：横图 1080*675，{verticalImgText}
            {_isWeddingDressProperty ? ' 526*702' : ' 540*540'}，大小不能超过 10
            MB，支持jpg、png 和 bmp 等格式。
          </p>
        </div>
        <div style={style}>
          <Upload
            // eslint-disable-next-line no-undef
            javaUpTokenUrl={`${__JAVA__DOMAIN__}/hms/mediacenter/appApi/media/app/token?from=MerchantImage`}
            clipabled
            width={194}
            height={120}
            aspect={1080 / 675}
            onBeforeUp={this.onBeforeUp}
            onCliped={this.onCliped('cover_img')}
            link={coverImg}
            noUploadMark={true}
            description={
              <div className={Style['upload_des']}>
                <div className={Style['upload_add']}>+</div>
                <p>{isMutile ? '横图' : '封面'}</p>
                <p>1080*675px</p>
              </div>
            }
            onDelete={this.onDelete('cover_img')}
            autoSizeError={true}
            max_file_size="10mb"
            filters={{
              mime_types: [
                {
                  title: 'images files',
                  extensions: 'jpg,gif,png,jpeg,bmp'
                }
              ],
              max_file_size: '10mb',
              prevent_duplicates: false
            }}
          />
        </div>
        {isMutile && (
          <div style={style}>
            <VerticalImgUploader
              title="选取案例横图"
              horizonImg={coverImg}
              width={_isWeddingDressProperty ? 90 : 120}
              height={120}
              clipabled
              autoCut
              aspect={_isWeddingDressProperty ? 526 / 702 : 540 / 540}
              onCliped={this.onCliped('up_cover_img')}
              value={upCoverImg}
              hidePlusIcon
              limitWidth={_isWeddingDressProperty ? 526 : 540}
              limitHeight={_isWeddingDressProperty ? 702 : 540}
              description={
                <div className={Style['upload_des']}>
                  <div className={Style['upload_add']}>+</div>
                  <p>{_isWeddingDressProperty ? '竖图' : '方图'}</p>
                  <p>{_isWeddingDressProperty ? '526*702px' : '540*540px'}</p>
                </div>
              }
              onDelete={this.onDelete('up_cover_img')}
              uploadConfig={{
                max_file_size: '10mb',
                filters: {
                  mime_types: [
                    {
                      title: 'images files',
                      extensions: 'jpg,gif,png,jpeg,bmp'
                    }
                  ],
                  max_file_size: '10mb',
                  prevent_duplicates: true
                }
              }}
            />
          </div>
        )}
      </Fragment>
    )
  }
}
